import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { Divider } from '@material-ui/core';
import { Button } from '../../../../common/button/Button';
import { EditOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../../../styles/colors';
import { AssignmentQuestionType } from '../../state/assignment-edit.types';

const useStyles = makeStyles({
  root: {
    border: `1px solid ${colors.assignment.grey}`
  },
  padding: {
    padding: '1.2rem'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  }
});

interface AssignmentEditorEmptyStateProps {
  handleQuestionType(type: AssignmentQuestionType): void;
}

const AssignmentEditorEmptyState: React.FC<AssignmentEditorEmptyStateProps> = (
  props: any
) => {
  const classes = useStyles();
  const { handleQuestionType } = props;
  return (
    <Grid container>
      <Grid item className={`${classes.padding}`} xs={12}>
        <b>Choose a question type</b>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item className={`${classes.padding} ${classes.actions}`} xs={12}>
        <>
          <Button
            onClick={() =>
              handleQuestionType(AssignmentQuestionType.Independent)
            }
            variant={'outline'}
            color={'black'}
            icon={EditOutlined}
          >
            Syntax / Word Question
          </Button>
          <Button
            onClick={() => handleQuestionType(AssignmentQuestionType.Passage)}
            variant={'outline'}
            color={'black'}
            icon={EditOutlined}
          >
            Reading Comprehension Question
          </Button>
        </>
      </Grid>
    </Grid>
  );
};

export default AssignmentEditorEmptyState;
